export enum EmergencyConnectionPoint {
  /** PSAP is the preferred connection point if the caller's location can be determined. */
  PSAP = 'PSAP',
  /** ECRC is the fallback/default connection point. */
  ECRC = 'ECRC',
  OTHER = 'OTHER',
}
